var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_today",
    clipPath: "url(#clip0_6158_90776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1458",
    d: "M17.5 5.5H16.75V4H15.25V5.5H7.75V4H6.25V5.5H5.5C5.10218 5.5 4.72064 5.65804 4.43934 5.93934C4.15804 6.22064 4 6.60218 4 7V19C4 19.3978 4.15804 19.7794 4.43934 20.0607C4.72064 20.342 5.10218 20.5 5.5 20.5H17.5C17.8978 20.5 18.2794 20.342 18.5607 20.0607C18.842 19.7794 19 19.3978 19 19V7C19 6.60218 18.842 6.22064 18.5607 5.93934C18.2794 5.65804 17.8978 5.5 17.5 5.5ZM17.5 19H5.5V9.25H17.5V19Z",
    fill: "#438AFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6158_90776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendarToday.04e4fe63c13e073e07670099ff28c416.svg";
export { ForwardRef as ReactComponent };